interface AthleteTeamData {
  id: number;
  athleteId: number;
  teamId: number;
  createDate: string;
  createrId: number;
  updateDate: string;
  updaterId: number;
  deleteDate: string;
  deleterId: number;
}


export class AthleteTeam {
  public static getNonTranslatableFields(): string[] { return ['id', 'athleteId', 'teamId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return []; }
  public static getFields(): string[] { return ['id', 'athleteId', 'teamId', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  athleteId?: number;
  teamId?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;

  public static fromAPI(data: AthleteTeamData): AthleteTeam {
    return new AthleteTeam(data);
  }

  public static fromAPIList(data: AthleteTeamData[]): AthleteTeam[] {
    return data.map((item: AthleteTeamData) => AthleteTeam.fromAPI(item));
  }

  constructor({id, athleteId, teamId, createDate, createrId, updateDate, updaterId, deleteDate, deleterId} : AthleteTeamData) {
    this.id = id;
    this.athleteId = athleteId;
    this.teamId = teamId;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
  }

  public toJson(): Object {
    return {
      id: this.id,
      athleteId: this.athleteId,
      teamId: this.teamId,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId
    };
  }
}
